import ViewsMenuDesktop from '@/components/atoms/garageViewsMenu/viewsMenuDesktop'
import ViewsMenuMobile from '@/components/atoms/garageViewsMenu/viewsMenuMobile'
import NoCarsInGarage from '@/components/atoms/noCars/noCarsInGarage'
import UserBanner from '@/components/atoms/user/userBanner'
import UserBox from '@/components/atoms/user/userBox'
import GarageViewManagerDesktop from '@/components/molecules/garageViewManager/garageViewManagerDesktop'
import GarageViewManagerMobile from '@/components/molecules/garageViewManager/garageViewManagerMobile'
import NotFound from '@/components/organisms/notFound'
import GarageSEO from '@/components/seo/garageSEO'
import Faded from '@/components/templates/animated/faded'
import DesktopDisplayOnly from '@/components/templates/displays/desktopDisplayOnly'
import { device } from '@/components/templates/displays/devices'
import IpadAndMobileDisplay from '@/components/templates/displays/ipadAndMobileDisplay'
import GaragePageLayout from '@/components/templates/pageLayouts/garagePageLayout'
import CenteredPageWrapper from '@/components/templates/wrappers/centeredPageWrapper'
import { mock_garage } from '@/context/mock_data'
import { converError } from 'data_conversions/convertError'
import { convertGarageApiToCtxGarage } from 'data_conversions/GarageToGarageStateConversion'

import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { ICar, IError, IGalleryImage, IGarage } from 'shared-interfaces'
import styled from 'styled-components'

// import styled from 'styled-components'
import GlobalCtx, { IGlobalCtx } from '../../../context/global'

const ViewsWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 30px;
`

const OwnerInfoWrapperMobile = styled.div`
    width: 100%;
    padding: 20px;
    padding-top: 30px;
    padding-bottom: 10px;
`

const OwnerBioMobile = styled.div`
    width: 100%;
    padding-top: 30px;
    padding-bottom: 0px;
    font-size: 14px;
    font-family: Lato;
    line-height: 20px;
`

const GarageDesktopWrapper = styled.div`
    @media ${device.beyond_ipad_mobile} {
        margin-top: -30px;
    }
    @media ${device.ipad} {
        margin-top: 50px;
    }
`

// here will add serverSideProps
export async function getServerSideProps(context: any) {
    const requestOptions: RequestInit = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
    }

    let noProps = {
        props: { garage: {} },
    }

    if (context.query.link_id === 'garageid') {
        return noProps
    }
    const res = await fetch(
        `${process.env.API_BASE_URL}/public/shares/garage-${context.query.link_id}`,
        requestOptions
    )

    if (res) {
        const data = await res.json()

        if (data) {
            if (data.garage) {
                let garage: IGarage | null = convertGarageApiToCtxGarage({
                    ...data,
                    uid: context.query.link_id,
                })

                return {
                    props: { garage: garage, host: context.req.headers.host },
                }
            } else {
                let error: IError | null = converError({
                    ...data,
                    uid: context.query.link_id,
                })
                // cookie.serialize('session_car_data', 'ok')
                return {
                    props: { error: error },
                }
            }
        } else return noProps
    } else return noProps
}

const Garage = (props: { garage?: IGarage; error?: IError; host: string }) => {
    const router = useRouter()
    const globalCtx: IGlobalCtx = React.useContext(GlobalCtx)

    useEffect(() => {
        if (router.query.link_id === 'garageid') {
            globalCtx.setGarage && globalCtx.setGarage(mock_garage)
        } else if (props.garage) {
            globalCtx.setGarage && globalCtx.setGarage(props.garage)
        } else if (props.error) {
            globalCtx.setGarage && globalCtx.setGarage(null),
                globalCtx.setError(props.error)
        }
    }, [props, globalCtx, router])

    const [activeView, setActiveView] = useState<'grid_view' | 'banner_view'>(
        'grid_view'
    )

    let link_id = router.query.link_id

    const get_cover_img = (carObj: ICar): IGalleryImage | undefined => {
        let imageid = carObj && carObj.cover_image_id && carObj.cover_image_id

        if (imageid) {
            if (carObj && carObj.galleryData && carObj.galleryData[imageid]) {
                return carObj.galleryData[imageid]
            }
        } else return undefined
    }

    return props.garage || globalCtx.garage ? (
        <>
            <GarageSEO garageData={props.garage} url={props.host} />
            {globalCtx.garage && (
                <GaragePageLayout>
                    <CenteredPageWrapper>
                        <DesktopDisplayOnly>
                            <Faded>
                                <GarageDesktopWrapper>
                                    <UserBanner garage={globalCtx.garage} />
                                    <ViewsWrapper>
                                        <ViewsMenuDesktop
                                            activeView={activeView}
                                            setGridView={() =>
                                                setActiveView('grid_view')
                                            }
                                            setBannerView={() =>
                                                setActiveView('banner_view')
                                            }
                                        />
                                    </ViewsWrapper>
                                    {globalCtx.garage.carIdsList &&
                                    globalCtx.garage.carIdsList.length > 0 ? (
                                        <GarageViewManagerDesktop
                                            activeView={activeView}
                                            carsIdList={
                                                globalCtx.garage.carIdsList
                                            }
                                            carsData={globalCtx.garage.carsData}
                                            areCarsLoading={false}
                                            garage_link_id={link_id}
                                            get_cover_img={get_cover_img}
                                        />
                                    ) : (
                                        <NoCarsInGarage variant="desktop" />
                                    )}
                                </GarageDesktopWrapper>
                            </Faded>
                        </DesktopDisplayOnly>
                        <IpadAndMobileDisplay>
                            <OwnerInfoWrapperMobile>
                                <UserBox
                                    userName={
                                        globalCtx.garage?.owner.fullname
                                            ? globalCtx.garage?.owner.fullname
                                            : 'John Smith'
                                    }
                                    userLocation={
                                        globalCtx.garage?.owner.location
                                            ? globalCtx.garage?.owner.location
                                            : 'Unknown'
                                    }
                                    profile_image_url={
                                        globalCtx &&
                                        globalCtx.garage &&
                                        globalCtx.garage.owner.profile_image_url
                                            ? globalCtx.garage.owner
                                                  .profile_image_url
                                            : undefined
                                    }
                                />
                                <OwnerBioMobile>
                                    {globalCtx.garage?.owner.bio}
                                </OwnerBioMobile>
                            </OwnerInfoWrapperMobile>
                            <ViewsMenuMobile
                                activeView={activeView}
                                setGridView={() => setActiveView('grid_view')}
                                setBannerView={() =>
                                    setActiveView('banner_view')
                                }
                            />
                            {globalCtx.garage.carIdsList &&
                            globalCtx.garage.carIdsList.length > 0 ? (
                                <div style={{ position: 'relative' }}>
                                    <GarageViewManagerMobile
                                        activeView={activeView}
                                        get_cover_img={get_cover_img}
                                        carsIdList={globalCtx.garage.carIdsList}
                                        carsData={globalCtx.garage.carsData}
                                        areCarsLoading={false}
                                        garage_link_id={link_id}
                                    />
                                </div>
                            ) : (
                                <div style={{ paddingTop: '50px' }}>
                                    <NoCarsInGarage variant="mobile" />
                                </div>
                            )}
                        </IpadAndMobileDisplay>
                    </CenteredPageWrapper>
                </GaragePageLayout>
            )}
        </>
    ) : (
        <NotFound isGarage />
    )
}

export default Garage
